import styled from "styled-components";

export const Paragraph = styled.p`
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;
`;

export const H1 = styled.h1`
  font-size: ${props => props.theme.fontSizes.h1}rem;
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;
  font-weight: bold;

  @media (max-width: ${props => props.theme.breakpoints.mobile}px) {
    font-size: ${props => props.theme.mobileFontSizes.h1}rem;
  }
`;

export const H2 = styled.h2`
  font-size: ${props => props.theme.fontSizes.h2}rem;
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;

  @media (max-width: ${props => props.theme.breakpoints.mobile}px) {
    font-size: ${props => props.theme.mobileFontSizes.h2}rem;
  }
`;

export const H3 = styled.h3`
  font-size: ${props => props.theme.fontSizes.h3}rem;
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;
  @media (max-width: ${props => props.theme.breakpoints.mobile}px) {
    font-size: ${props => props.theme.mobileFontSizes.h3}rem;
  }
`;

export const H4 = styled.h4`
  font-size: ${props => props.theme.fontSizes.h4}rem;
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;
  @media (max-width: ${props => props.theme.breakpoints.mobile}px) {
    font-size: ${props => props.theme.mobileFontSizes.h4}rem;
  }
`;

export const H5 = styled.h5`
  font-size: ${props => props.theme.fontSizes.h5}rem;
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;
  @media (max-width: ${props => props.theme.breakpoints.mobile}px) {
    font-size: ${props => props.theme.mobileFontSizes.h5}rem;
  }
`;

export const H6 = styled.h6`
  font-size: ${props => props.theme.fontSizes.h6}rem;
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;
  @media (max-width: ${props => props.theme.breakpoints.mobile}px) {
    font-size: ${props => props.theme.mobileFontSizes.h6}rem;
  }
`;

export const SmallText = styled.p`
  font-size: ${props => props.theme.fontSizes.small}rem;
  color: ${props => props.theme.colors.inverse};
  margin-bottom: 2rem;
  @media (max-width: ${props => props.theme.breakpoints.mobile}px) {
    font-size: ${props => props.theme.mobileFontSizes.p}rem;
  }
`;
